import { element } from "./ui";

type ThemePreference = "light" | "dark" | "system";

export function initializeTheme(): void {
  const select = element<HTMLSelectElement>("themeSelect");
  const device = window.matchMedia("(prefers-color-scheme: dark)");
  let preference: ThemePreference = "light";
  try {
    const saved = window.localStorage.getItem("theme");
    if (saved === "light" || saved === "dark" || saved === "system") preference = saved;
  } catch {}
  const apply = (): void => {
    const theme = preference === "system" ? (device.matches ? "dark" : "light") : preference;
    document.documentElement.dataset.theme = theme;
    select.value = preference;
    document.querySelector<HTMLMetaElement>('meta[name="color-scheme"]')!.content = theme;
    document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')!.content = window.getComputedStyle(document.documentElement).getPropertyValue("--bg").trim();
  };
  select.addEventListener("change", () => {
    preference = select.value as ThemePreference;
    apply();
    try { window.localStorage.setItem("theme", preference); } catch {}
  });
  device.addEventListener("change", apply);
  apply();
}
